import { z } from "zod";

/**
 * Single item card template group
 */
export const SingleItemCardTemplateGroupSchema = z.object({
  availableTemplates: z.array(
    z.object({
      language: z.string(),
      templateId: z.string()
    })
  )
});

export type SingleItemCardTemplateGroup = z.infer<typeof SingleItemCardTemplateGroupSchema>;
